export const allowedSizeFiles = 1024 * 1024 * 1024;

export const toLargeFileSize = 'Размер изображения не должен превышать больше 10 мегабайт';
